"use client";
import React from "react";
import { Container } from "react-bootstrap";
import EventCalendarEntry from "@/components/events/EventCalendarEntry";
import { useMediaQuery } from "react-responsive";

var moment = require("moment");

const EventKioskScheduleView = ({
  event,
  eventSchedule,
  flattenedParticipants,
  startDate
}) => {

  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  var scheduleToRender = eventSchedule;

  if (event && event.multiDay && event.startDate && event.endDate) {
    var eventStart = moment(event.startDate.date).startOf("day");
    var eventEnd = moment(event.endDate.date).endOf("day");
    var now = moment();
    if (now.isSameOrAfter(eventStart) && now.isSameOrBefore(eventEnd)) {
      scheduleToRender = (eventSchedule || []).filter(subEvt => {
        if (!subEvt.startDate) return false;
        var subStart = moment(subEvt.startDate.date).startOf("day");
        var subEnd = subEvt.endDate
          ? moment(subEvt.endDate.date).endOf("day")
          : moment(subEvt.startDate.date).endOf("day");
        return now.isSameOrAfter(subStart) && now.isSameOrBefore(subEnd);
      });
    }
  }

  return (
    <div className="kiosk-subpage-body">
      <Container>
        <div className="event-calendar">
          {scheduleToRender &&
            scheduleToRender.map(subEvt => {
              var participants =
                subEvt.participants &&
                flattenedParticipants &&
                flattenedParticipants.filter(
                  p => subEvt.participants.findIndex(pa => pa.id === p.id) > -1
                );
              return (
                <EventCalendarEntry
                  key={`kiosk-event-calendar-entry-${subEvt.id}`}
                  queryDate={startDate}
                  event={subEvt}
                  community={null}
                  external={false}
                  coordinates={null}
                  showMap={false}
                  small={isSm}
                  onClick={null}
                  onShowEventsAtLocation={null}
                  participants={participants}
                  showEventDate={false}
                />
              );
            })}
        </div>
      </Container>
    </div>
  );
};

export default EventKioskScheduleView;
